<div class="container"
  [ngClass]="{'flipped' : flipped,  'full-ability': settingsManager.settings.showFullAbilityCard || settingsManager.settings.showExpandedAbilityCard, 'expanded-ability': settingsManager.settings.showExpandedAbilityCard && flipped, 'bottom-actions' : hasBottomActions, 'second-ability' : secondAbility,'fh' : settingsManager.settings.fhStyle,  'disabled' : !settingsManager.settings.abilities, 'denied' : monster && gameManager.stateManager.permissions && !gameManager.stateManager.monsterPermissions[monster.name + '|' + monster.edition] }">
  <div
    *ngIf="!secondAbility && !settingsManager.settings.showFullAbilityCard && !settingsManager.settings.showExpandedAbilityCard"
    class="hover-effect initiative"></div>
  <div
    *ngIf="!secondAbility && !settingsManager.settings.showFullAbilityCard && !settingsManager.settings.showExpandedAbilityCard"
    class="hover-effect title"></div>
  <ghs-ability [ability]="ability" [monster]="monster" [flipped]="flipped"
    [interactiveAbilities]="settingsManager.settings.interactiveAbilities" ghs-pointer-input
    (singleClick)="openAbilities($event)" (doubleClick)="openAbility($event)"></ghs-ability>
  <ng-container *ngIf="!!secondAbility">
    <ghs-ability [ability]="secondAbility" [monster]="monster" [flipped]="flipped"
      [interactiveAbilities]="settingsManager.settings.interactiveAbilities" ghs-pointer-input
      (singleClick)="openAbilities($event)" (doubleClick)="openAbility($event,true)">
    </ghs-ability>
  </ng-container>
</div>
<span class="left-abilities" *ngIf="settingsManager.settings.abilities">
  {{this.monster.abilities.length - drawnAbilities - (secondAbility ? 1 : 0)}}/{{this.monster.abilities.length}}
</span>